import { member } from '@/api/members'
import { common } from '@/api/common'
import { approval } from '@/api/approval'
import store from '@/store'


const pattern = /[0-9]/
let res = null

export const members = {
    namespaced: true,
    state: {
        //나의정보
        myAddress: null,
        myCar: null,
        myCareer: null,
        myLicense: null,
        myEducation: null,
        myCommute: null,

        //프로파일 정보
        profileBranch: null,
        profileSalary: null,
        profileTime: null,
        profileType: null,

        //나의고충
        distresses: null,

        //나의 휴가사용현황
        useVacation: null,

        //나의 보관함
        myFiles: null,
        searchWord: null,
        requiredList: null,

        //나의 출퇴근현황
        myCommuteList: null,

        //나의 급여명세서
        myPayslips: null,
        selectedBranch: null
    },
    mutations: {
        MY_ADDRESS(state, payload) {
            state.myAddress = payload.addressInfo
        },
        REGIST_MY_ADDRESS(state, payload) {
            if (!state.myAddress) {
                state.myAddress = []
            }
            if (state.myAddress && state.myAddress.length !== 0) {
                let index = state.myAddress.findIndex(item => item.defaultYn === 'Y')
                state.myAddress[index].defaultYn = 'N'
            }
            state.myAddress.unshift(payload.userAddress)
        },
        DEFAULT_MY_ADDRESS(state, payload) {
            let index = state.myAddress.findIndex(item => item.defaultYn === 'Y')
            state.myAddress[index].defaultYn = 'N'
            state.myAddress[payload].defaultYn = 'Y'
        },
        UPDATE_MY_ADDRESS(state, payload) {
            state.myAddress.splice(payload.index, 1, payload.info.userAddress)
        },
        DELETE_MY_ADDRESS(state, payload) {
            state.myAddress.splice(payload, 1)
        },
        UPDATE_MY_EMAIL(state, payload) {
            store.state.userInfo.email = payload.userInfo.email
        },
        UPDATE_MOBILE_NO(state, payload) {
            store.state.userInfo.mobileNo = payload
        },
        UPDATE_BIRTHDAY(state, payload) {
            store.state.userInfo.birthday = payload.userInfo.birthday
        },
        MY_CAR(state, payload) {
            state.myCar = payload.userCarInfo
        },
        REGIST_MY_CAR(state, payload) {
            if (!state.myCar) state.myCar = []
            state.myCar.unshift(payload.carInfo)
        },
        UPDATE_MY_CAR(state, payload) {
            let index = state.myCar.findIndex(item => item.carMyinfoIdx === payload.updateCarInfo.carMyinfoIdx)
            state.myCar.splice(index, 1, payload.updateCarInfo)
        },
        DELETE_MY_CAR(state, payload) {
            state.myCar.splice(payload, 1)
            if (!state.myCar.length) state.myCar = null
        },
        DELETE_MY_CAR_IMAGE(state, payload) {
            state.myCar[payload].carPhotoFileIdx = null
        },
        MY_CAREER(state, payload) {
            state.myCareer = payload.careerInfo
        },
        REGIST_MY_CAREER(state, payload) {
            if (!state.myCareer) state.myCareer = []
            state.myCareer.unshift(payload.userCareerInfo)
        },
        UPDATE_MY_CAREER(state, payload) {
            let index = state.myCareer.findIndex(item => item.userCareerIdx === payload.userCareerInfo.userCareerIdx)
            state.myCareer.splice(index, 1, payload.userCareerInfo)
        },
        DELETE_MY_CAREER(state, payload) {
            state.myCareer.splice(payload, 1)
            if (!state.myCareer.length) state.myCareer = null
        },
        MY_LICENSE(state, payload) {
            state.myLicense = payload.userCertificate
        },
        REGIST_MY_LICENSE(state, payload) {
            if (!state.myLicense) state.myLicense = []
            state.myLicense.unshift(payload.userCertificate)
        },
        UPDATE_MY_LICENSE(state, payload) {
            let index = state.myLicense.findIndex(item => item.userCertificateIdx === payload.userCertificate.userCertificateIdx)
            state.myLicense.splice(index, 1, payload.userCertificate)
        },
        DELETE_MY_LICENSE(state, payload) {
            state.myLicense.splice(payload, 1)
            if (!state.myLicense.length) state.myLicense = null
        },
        DELETE_MY_LICENSE_IMAGE(state, payload) {
            state.myLicense[payload].certificateCopyFileIdx = null
        },
        MY_EDUCATION(state, payload) {
            state.myEducation = payload.eduInfo
        },
        REGIST_MY_EDUCATION(state, payload) {
            if (!state.myEducation) state.myEducation = []
            state.myEducation.unshift(payload.eduInfo)
        },
        UPDATE_MY_EDUCATION(state, payload) {
            let index = state.myEducation.findIndex(item => item.userEducationInfoIdx === payload.eduInfo.userEducationInfoIdx)
            state.myEducation.splice(index, 1, payload.eduInfo)
        },
        DELETE_MY_EDUCATION(state, payload) {
            state.myEducation.splice(payload, 1)
            if (!state.myEducation.length) state.myEducation = null
        },
        DELETE_MY_EDUCATION_IMAGE(state, payload) {
            state.myEducation[payload].commonAttachFileIdx = null
        },
        MY_PROFILE(state, payload) {
            state.profileBranch = payload.profileBranch
            state.profileSalary = payload.profileSalary
            state.profileTime = payload.profileTime
            state.profileType = payload.profileType
        },
        REGIST_PROFILE_BRANCH(state, payload) {
            state.profileBranch = payload.pbrList
        },
        DELETE_PROFILE_BRANCH(state, payload) {
            state.profileBranch.splice(payload, 1)
            if (!state.profileBranch.length) state.profileBranch = null
        },
        REGIST_TIME(state, payload) {
            if (!state.profileTime) state.profileTime = []
            state.profileTime.push(payload)
        },
        DELETE_TIME(state, payload) {
            state.profileTime.splice(payload, 1)
        },
        UPDATE_SEEK_JOB(state, payload) {
            store.state.userInfo.seekJobYn = payload.memberInfo.seekJobYn
        },
        MY_COMMUTE(state, payload) {
            if (payload.staffCommuteList)
                state.myCommute = payload.staffCommuteList[0]
            else
                state.myCommute = null
        },
        SUBMIT_COMMUTE(state, payload) {
            state.myCommute = payload.staffCommuteInfo
        },
        MY_DISTRESSES(state, payload) {
            state.distresses = payload.distressList
            state.distressesYear = payload.distressYear
        },
        REGIST_DISTRESSES(state, payload) {
            if (!state.distresses) state.distresses = []
            console.log(payload)
            if (payload.year === payload.info.createYmdhms.substr(0, 4)) {
                state.distresses.unshift(payload.info)
            }
        },
        DELETE_DISTRESSES(state, payload) {
            let index = state.distresses.findIndex(item => item.boardIdx === payload)
            state.distresses.splice(index, 1)
            if (!state.distresses.length) state.distresses = null
        },
        MY_USE_VACATION(state, payload) {
            state.useVacation = payload.vacationInfo
        },
        MY_FILES(state, payload) {
            state.myFiles = payload.userFileBoxList
        },
        DELETE_MY_FILES(state, payload) {
            let index = state.myFiles.findIndex(item => item.commonAttachFileIdx === payload)
            state.myFiles.splice(index, 1)
            if (!state.myFiles.length) state.myFiles = null
        },
        SET_SEARCH_WORD(state, payload) {
            state.searchWord = payload
        },
        MY_COMMUTE_LIST(state, payload) {
            state.myCommuteList = payload.commuteList
            console.log(state.myCommuteList)
        },
        MY_PAYSLIP(state, payload) {
            state.myPayslips = payload.staffPayslipDescList
        },
        SET_SELECT_BRANCH(state, payload) {
            state.selectedBranch = payload
        },
        REQUIRED_LIST(state, payload) {
            state.requiredList = payload.list
        },
        SUBMIT_FILE(state, payload) {
            let index = state.requiredList.findIndex(item => item.pushNotiIdx === payload)
            if (index !== -1) state.requiredList.splice(index, 1)
        }
    },
    actions: {
        // @Description 나의주소지 조회
        async MY_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.address(payload)
                console.log('MY_ADDRESS info', res)
                if (res.data.status === 200) {
                    commit('MY_ADDRESS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_ADDRESS error', error)
            }
        },
        // @Description 나의주소지 등록
        async REGIST_MY_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.address(payload)
                console.log('REGIST_MY_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', inset: false })
                    commit('REGIST_MY_ADDRESS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_ADDRESS error', error)
            }
        },
        // @Description 나의주소 기본주소지 설정
        async DEFAULT_MY_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.defaultAddress(payload)
                console.log('DEFAULT_MY_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', inset: false })
                    commit('DEFAULT_MY_ADDRESS', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DEFAULT_MY_ADDRESS error', error)
            }
        },
        // @Description 나의주소지 수정
        async UPDATE_MY_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.updateAddress(payload)
                console.log('UPDATE_MY_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', inset: false })
                    commit('UPDATE_MY_ADDRESS', { info: res.data.data, index: payload.index })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_ADDRESS error', error)
            }
        },
        // @Description 나의주소지 삭제
        async DELETE_MY_ADDRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.address(payload)
                console.log('DELETE_MY_ADDRESS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', inset: false })
                    commit('DELETE_MY_ADDRESS', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_ADDRESS error', error)
            }
        },
        // @Description 패스워드 변경
        async UPDATE_MY_PASSWORD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.resetLoginPwd(payload)
                console.log('UPDATE_MY_PASSWORD info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_PASSWORD error', error)
            }
        },
        // @Description 이메일 변경
        async UPDATE_MY_EMAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.email(payload)
                console.log('UPDATE_MY_EMAIL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MY_EMAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_EMAIL error', error)
            }
        },
        // @Description 휴대전화번호 변경 전 인증번호 발급
        async CHECK_MY_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.phoneNoReset(payload)
                console.log('CHECK_MY_INFO info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    store.commit('CHECK_USER_INFO', { data: res.data.data, info: payload })
                    store.commit('AUTH_DATA', { data: res.data.data, info: payload })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHECK_MY_INFO error', error)
            }
        },
        // @Description 생년월일 변경
        async UPDATE_BIRTHDAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.base(payload)
                console.log('UPDATE_BIRTHDAY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BIRTHDAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BIRTHDAY error', error)
            }
        },
        // @Description 차량정보 조회
        async MY_CAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.carInfo(payload)
                console.log('MY_CAR info', res)
                if (res.data.status === 200) {
                    commit('MY_CAR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_CAR error', error)
            }
        },
        // @Description 차량정보 등록
        async REGIST_MY_CAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.carInfo(payload)
                console.log('REGIST_MY_CAR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MY_CAR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_CAR error', error)
            }
        },
        // @Description 차량정보 수정
        async UPDATE_MY_CAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.updateCarInfo(payload)
                console.log('UPDATE_MY_CAR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MY_CAR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_CAR error', error)
            }
        },
        // @Description 차량정보 삭제
        async DELETE_MY_CAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.carInfo(payload)
                console.log('DELETE_MY_CAR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_CAR', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_CAR error', error)
            }
        },
        // @Description 차량이미지 삭제
        async DELETE_MY_CAR_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_MY_CAR_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_CAR_IMAGE', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_CAR_IMAGE error', error)
            }
        },
        // @Description 경력정보 조회
        async MY_CAREER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.career(payload)
                console.log('MY_CAREER info', res)
                if (res.data.status === 200) {
                    commit('MY_CAREER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_CAREER error', error)
            }
        },
        // @Description 경력정보 등록
        async REGIST_MY_CAREER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.career(payload)
                console.log('REGIST_MY_CAREER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MY_CAREER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_CAREER error', error)
            }
        },
        // @Description 경력정보 수정
        async UPDATE_MY_CAREER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.updateCareer(payload)
                console.log('UPDATE_MY_CAREER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MY_CAREER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_CAREER error', error)
            }
        },
        // @Description 경력정보 삭제
        async DELETE_MY_CAREER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.career(payload)
                console.log('DELETE_MY_CAREER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_CAREER', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_CAREER error', error)
            }
        },
        // @Description 자격정보 조회
        async MY_LICENSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.license(payload)
                console.log('MY_LICENSE info', res)
                if (res.data.status === 200) {
                    commit('MY_LICENSE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_LICENSE error', error)
            }
        },
        // @Description 자격정보 등록
        async REGIST_MY_LICENSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.license(payload)
                console.log('REGIST_MY_LICENSE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MY_LICENSE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_LICENSE error', error)
            }
        },
        // @Description 자격정보 수정
        async UPDATE_MY_LICENSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.updateLicense(payload)
                console.log('UPDATE_MY_LICENSE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MY_LICENSE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_LICENSE error', error)
            }
        },
        // @Description 자격정보 삭제
        async DELETE_MY_LICENSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.license(payload)
                console.log('DELETE_MY_LICENSE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_LICENSE', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_LICENSE error', error)
            }
        },
        // @Description 자격정보 이미지 삭제
        async DELETE_MY_LICENSE_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_MY_LICENSE_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_LICENSE_IMAGE', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_LICENSE_IMAGE error', error)
            }
        },
        // @Description 교육정보 조회
        async MY_EDUCATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.education(payload)
                console.log('MY_EDUCATION info', res)
                if (res.data.status === 200) {
                    commit('MY_EDUCATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_EDUCATION error', error)
            }
        },
        // @Description 교육정보 등록
        async REGIST_MY_EDUCATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.education(payload)
                console.log('REGIST_MY_EDUCATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MY_EDUCATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_EDUCATION error', error)
            }
        },
        // @Description 교육정보 수정
        async UPDATE_MY_EDUCATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.updateEducation(payload)
                console.log('UPDATE_MY_EDUCATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MY_EDUCATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MY_EDUCATION error', error)
            }
        },
        // @Description 교육정보 삭제
        async DELETE_MY_EDUCATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.education(payload)
                console.log('DELETE_MY_EDUCATION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_EDUCATION', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_EDUCATION error', error)
            }
        },
        // @Description 교육정보 이미지 삭제
        async DELETE_MY_EDUCATION_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_MY_EDUCATION_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_EDUCATION_IMAGE', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_EDUCATION_IMAGE error', error)
            }
        },
        // @Description 프로파일 조회
        async MY_PROFILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.profile(payload)
                console.log('MY_PROFILE info', res)
                if (res.data.status === 200) {
                    commit('MY_PROFILE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_PROFILE error', error)
            }
        },
        // @Description 프로파일 등록
        async REGIST_MY_PROFILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.profile(payload)
                console.log('REGIST_MY_PROFILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_PROFILE error', error)
            }
        },
        // @Description 프로파일 기관등록
        async REGIST_PROFILE_BRANCH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.profileBranch(payload)
                console.log('REGIST_SEARCH_BRANCH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_PROFILE_BRANCH', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SEARCH_BRANCH error', error)
            }
        },
        // @Description 프로파일 기관삭제
        async DELETE_PROFILE_BRANCH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.profileBranch(payload)
                console.log('DELETE_PROFILE_BRANCH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_PROFILE_BRANCH', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_PROFILE_BRANCH error', error)
            }
        },
        // @Description 구직활동 수정 가능여부 조회
        async CHECK_SEEK_JOB({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.confirmInfo(payload)
                console.log('CHECK_SEEK_JOB info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHECK_SEEK_JOB error', error)
            }
        },
        // @Description 구직활동 여부 수정
        async UPDATE_SEEK_JOB({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.usageJobPlan(payload)
                console.log('UPDATE_SEEK_JOB info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_SEEK_JOB', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_SEEK_JOB error', error)
            }
        },
        // @Description 나의 출근정보 조회
        async MY_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.myCommute(payload)
                console.log('MY_COMMUTE info', res)
                if (res.data.status === 200) {
                    commit('MY_COMMUTE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_COMMUTE error', error)
            }
        },
        // @Description 나의 출근,퇴근,외근,외출 요청
        async SUBMIT_COMMUTE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.staffCommute(payload)
                console.log('SUBMIT_COMMUTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SUBMIT_COMMUTE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_COMMUTE', error)
            }
        },
        // @Description 나의고충 조회
        async MY_DISTRESSES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.distresses(payload)
                console.log('MY_DISTRESSES info', res)
                if (res.data.status === 200) {
                    commit('MY_DISTRESSES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_DISTRESSES error', error)
            }
        },
        // @Description 나의고충 저장
        async REGIST_DISTRESSES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.distresses(payload)
                console.log('REGIST_DISTRESSES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_DISTRESSES', {
                        year: payload.year,
                        info: res.data.data.distressInfo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DISTRESSES error', error)
            }
        },
        // @Description 나의고충 접수내역 삭제
        async DELETE_DISTRESSES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.delete.distresses(payload)
                console.log('DELETE_DISTRESSES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_DISTRESSES', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DISTRESSES error', error)
            }
        },
        // @Description 나의 휴가사용현황 조회
        async MY_USE_VACATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.useVacation(payload)
                console.log('MY_USE_VACATION info', res)
                if (res.data.status === 200) {
                    commit('MY_USE_VACATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_USE_VACATION error', error)
            }
        },
        // @Description 나의 보관함관리 요청받은 서류 리스트
        async REQUIRED_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.requiredFileList(payload)
                console.log('REQUIRED_LIST info', res)
                if (res.data.status === 200) {
                    commit('REQUIRED_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REQUIRED_LIST error', error)
            }
        },
        // @Description 요청받은 서류 제출
        async SUBMIT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.copyFile(payload)
                console.log('SUBMIT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SUBMIT_FILE', payload.pushNotiIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_FILE error', error)
            }
        },
        // @Description 나의 보관함관리 조회
        async MY_FILES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.fileBox(payload)
                console.log('MY_FILES info', res)
                if (res.data.status === 200) {
                    commit('MY_FILES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_FILES error', error)
            }
        },
        // @Description 나의 보관함 파일업로드
        async REGIST_MY_FILES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.fileBox(payload)
                console.log('REGIST_MY_FILES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MY_FILES error', error)
            }
        },
        // @Description 나의 보관함 파일삭제
        async DELETE_MY_FILES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_MY_FILES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MY_FILES', payload.fileIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MY_FILES error', error)
            }
        },
        // @Description 나의 출퇴근정보 조회(API는 결재페이지의 직원 출퇴근 조회 같이 사용)
        async MY_COMMUTE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.myCommuteCalendar(payload)
                console.log('MY_COMMUTE_LIST info', res)
                if (res.data.status === 200) {
                    commit('MY_COMMUTE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_COMMUTE_LIST', error)
            }
        },
        // @Description 나의 급여명세서 상세조회
        async MY_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.get.payslipDetail(payload)
                console.log('MY_PAYSLIP info', res)
                if (res.data.status === 200) {
                    commit('MY_PAYSLIP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MY_PAYSLIP', error)
            }
        },
        // @Description 종사자 등록정보 및 연결 확인
        async CONFIRM_MATCHING_WORKER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.confirm(payload)
                console.log('CONFIRM_MATCHING_WORKER info', res)
                if (res.data.status === 201) {
                    store.commit('RESET_PAGE')
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    store.commit('SET_TOKEN', res.data.data)
                    store.commit('SET_LOGIN_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                router.push({ name: 'MainDashboard' }).catch(() => {})
                setTimeout(() => { location.reload(); }, 1500)
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONFIRM_MATCHING_WORKER', error)
            }
        },
        // @Description 출퇴근 정보 수정요청
        async APPLY_COMMUTE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await member.post.staffCommute(payload)
                console.log('APPLY_COMMUTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPLY_COMMUTE', error)
            }
        }
    },
    getters: {
        DEFAULT_ADDRESS: state => {
            if (state.myAddress) {
                let arr = state.myAddress.filter(item => item.defaultYn === 'Y')
                return {
                    lat: arr[0].gpsLatitude,
                    lng: arr[0].gpsLongitude
                }
            } else {
                return null
            }
        },
        MY_INFO_COUNT: state => {
            let car = state.myCar ? state.myCar.length : 0
            let career = state.myCareer ? state.myCareer.length : 0
            let license = state.myLicense ? state.myLicense.length : 0
            let edu = state.myEducation ? state.myEducation.length : 0

            return {
                car: car,
                career: career,
                license: license,
                edu: edu
            }
        },
        SEARCH_FILE: state => {
            if (state.searchWord) {
                let arr = null
                if (state.myFiles) {
                    arr = state.myFiles.filter(item => item.filename.includes(state.searchWord))
                }
                return arr
            } else {
                return state.myFiles
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/members.js